const QUOTE_KEY = 'zilacab_quote';
const BOOKING_KEY = 'zilacab_booking';

const read = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage disabled — silently ignore, callers already navigate via router state
  }
};

const remove = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const saveQuote = (quote) => write(QUOTE_KEY, quote);
export const getQuote = () => read(QUOTE_KEY);
export const clearQuote = () => remove(QUOTE_KEY);

export const saveBooking = (booking) => write(BOOKING_KEY, booking);
export const getBooking = () => read(BOOKING_KEY);
export const clearBooking = () => remove(BOOKING_KEY);
